import React from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import './AInsteinPage.css';

const privacyPolicyHTML = `
  <div style="margin: 0; padding: 20px; font-family: system-ui, -apple-system, sans-serif; max-width: 800px; margin: 0 auto; line-height: 1.6;">
    <h1 style="font-size: 1.8rem; font-weight: 600; margin: 0 0 1rem 0; padding: 0; line-height: 1.2;">Privacy Policy</h1>
    <p style="margin: 0 0 2rem 0; color: #666;">Effective Date: June 21, 2025</p>
    
    <p style="margin: 0 0 2rem 0;">AInstein values your privacy. This Privacy Policy explains how we collect, use, and protect your information when you use our app.</p>
    
    <h2 style="font-size: 1.4rem; font-weight: 600; margin: 2rem 0 1rem 0; padding: 0;">1. Information We Collect</h2>
    
    <h3 style="font-size: 1.1rem; font-weight: 600; margin: 1.5rem 0 0.75rem 0;">a. Personal Information</h3>
    <p style="margin: 0 0 1rem 0;">We collect the following when you sign up or use the app:</p>
    <ul style="margin: 0 0 1.5rem 1.5rem; padding: 0;">
      <li style="margin: 0 0 0.5rem 0;">Email address</li>
      <li style="margin: 0 0 0.5rem 0;">Basic account metadata</li>
    </ul>
    
    <h3 style="font-size: 1.1rem; font-weight: 600; margin: 1.5rem 0 0.75rem 0;">b. User-Generated Content</h3>
    <p style="margin: 0 0 0.5rem 0;">When you upload content to generate study material (e.g., PDFs, images, audio, or text), we collect:</p>
    <ul style="margin: 0 0 1.5rem 1.5rem; padding: 0;">
      <li style="margin: 0 0 0.5rem 0;">Uploaded files</li>
      <li style="margin: 0;">AI-generated quizzes, flashcards, summaries, etc.</li>
    </ul>
    
    <h3 style="font-size: 1.1rem; font-weight: 600; margin: 1.5rem 0 0.75rem 0;">c. Usage Data</h3>
    <p style="margin: 0 0 0.5rem 0;">We may collect anonymized app usage statistics, such as:</p>
    <ul style="margin: 0 0 2rem 1.5rem; padding: 0;">
      <li style="margin: 0 0 0.5rem 0;">Feature usage frequency (e.g., how often flashcards are used)</li>
      <li style="margin: 0;">Error logs and crash reports</li>
    </ul>
    
    <h2 style="font-size: 1.4rem; font-weight: 600; margin: 2rem 0 1rem 0; padding: 0;">2. How We Use Your Data</h2>
    <p style="margin: 0 0 1rem 0;">We use your data to:</p>
    <ul style="margin: 0 0 2rem 1.5rem; padding: 0;">
      <li style="margin: 0 0 0.5rem 0;">Authenticate your identity and maintain your account</li>
      <li style="margin: 0 0 0.5rem 0;">Generate AI-powered study materials using third-party APIs</li>
      <li style="margin: 0 0 0.5rem 0;">Improve the app and user experience</li>
      <li style="margin: 0;">Provide personalized recommendations and reminders (if enabled)</li>
    </ul>
    
    <h2 style="font-size: 1.4rem; font-weight: 600; margin: 2rem 0 1rem 0; padding: 0;">3. AI Data Processing</h2>
    <p style="margin: 0 0 1rem 0;">We send your uploaded content (text, images, PDFs, audio, YouTube links) to third-party AI-powered services to generate study content. These files:</p>
    <ul style="margin: 0 0 1.5rem 1.5rem; padding: 0;">
      <li style="margin: 0 0 0.5rem 0;">May be briefly processed on remote servers</li>
      <li style="margin: 0 0 0.5rem 0;">Are stored in our database for user access</li>
    </ul>
    
    <h2 style="font-size: 1.4rem; font-weight: 600; margin: 2rem 0 1rem 0; padding: 0;">4. Data Storage & Security</h2>
    <p style="margin: 0 0 1rem 0;">All your personal data and study materials are securely stored on our servers.</p>
    <p style="margin: 0 0 2rem 0;">We implement industry-standard encryption and access controls to protect your data from unauthorized access, alteration, or disclosure.</p>
    
    <h2 style="font-size: 1.4rem; font-weight: 600; margin: 2rem 0 1rem 0; padding: 0;">5. Data Retention</h2>
    <p style="margin: 0 0 2rem 0;">We retain your data as long as your account is active. If you delete your account, your personal and uploaded content will be permanently deleted within 30 days.</p>
    
    <h2 style="font-size: 1.4rem; font-weight: 600; margin: 2rem 0 1rem 0; padding: 0;">6. Third-Party Services</h2>
    <p style="margin: 0 0 1rem 0;">We use:</p>
    <ul style="margin: 0 0 1.5rem 1.5rem; padding: 0;">
      <li style="margin: 0 0 0.5rem 0;">Supabase for authentication and database services</li>
      <li style="margin: 0 0 0.5rem 0;">Google Gemini APIs for AI-powered content generation</li>
      <li style="margin: 0;">Apple In-App Purchases / Google Play Billing for subscription management</li>
    </ul>
    <p style="margin: 0 0 2rem 0;">These services may have access to limited data necessary to perform their functions.</p>
    
    <h2 style="font-size: 1.4rem; font-weight: 600; margin: 2rem 0 1rem 0; padding: 0;">7. Your Rights</h2>
    <p style="margin: 0 0 1rem 0;">You have the right to:</p>
    <ul style="margin: 0 0 1.5rem 1.5rem; padding: 0;">
      <li style="margin: 0 0 0.5rem 0;">Access or correct your data</li>
      <li style="margin: 0 0 0.5rem 0;">Delete your account and data</li>
      <li style="margin: 0;">Revoke permissions (e.g., notifications)</li>
    </ul>
    
    <h2 style="font-size: 1.4rem; font-weight: 600; margin: 2rem 0 1rem 0; padding: 0;">8. Changes to this Policy</h2>
    <p style="margin: 0 0 2rem 0;">We may update this Privacy Policy from time to time. We will notify users of any significant changes via the app or email.</p>
    
    <h2 style="font-size: 1.4rem; font-weight: 600; margin: 2rem 0 1rem 0; padding: 0;">9. Contact Us</h2>
    <p style="margin: 0 0 0.5rem 0;">If you have questions about this Privacy Policy, reach out at:</p>
    <p style="margin: 0;">📧 <a href="mailto:pankaj6apr@outlook.com" style="color: #4f46e5; text-decoration: none; font-weight: 500;">pankaj6apr@outlook.com</a></p>
  </div>
`;

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="ainstein-app" style={{ 
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      paddingTop: '80px' 
    }}>
      <Header />
      <main style={{ 
        flex: 1,
        margin: '0 auto', 
        maxWidth: '800px', 
        width: '100%',
        padding: '0 1rem 1rem',
        color: '#333',
        fontFamily: 'system-ui, -apple-system, sans-serif',
      }}>
        <div style={{ lineHeight: '1.5' }} dangerouslySetInnerHTML={{ __html: privacyPolicyHTML }} />
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
